import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type AccountState = CommonTableState;

export const initialState: AccountState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "id", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            temporaryPassword: false,
        },
        columnOrder: [
            "mrt-row-select",
            "id",
            "person.id",
            "person.email",
            "disabled",
            "temporaryPassword",
            "lastLogin",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const accountSlice = createSlice({
    name: "account",
    initialState: initialState,
    reducers: {
        updateAccountTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateAccountTableState } = accountSlice.actions;

export default accountSlice.reducer;
